import { render, staticRenderFns } from "./DialogRepetirPosicionamento.vue?vue&type=template&id=49fab34c"
import script from "./DialogRepetirPosicionamento.vue?vue&type=script&lang=js"
export * from "./DialogRepetirPosicionamento.vue?vue&type=script&lang=js"
import style0 from "./DialogRepetirPosicionamento.vue?vue&type=style&index=0&id=49fab34c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports